import { StarCatchingGame, StarMineGame, MemoryGame } from "@/components/MiniGames";
import React, { useEffect, useState } from "react";
import SpellingSpells from "../components/SpellingSpells";


import { useNavigate, useParams } from "react-router-dom";
import {
    ArrowLeft,
    Clock,
    Gamepad2,
    Lock,
    Star,
    Sparkles,
    ShieldCheck,
    BookOpen,
} from "lucide-react";
import { toast } from "sonner";



const Arcade = () => {
    const navigate = useNavigate();
    const { childId } = useParams();


   
    const [child, setChild] = useState(null);
    const [approved, setApproved] = useState(false);
    const [selectedMinutes, setSelectedMinutes] = useState(15);
    const [timeLeft, setTimeLeft] = useState(0);
    const [game, setGame] = useState(null);
    const [paused, setPaused] = useState(false);
    const [spellingOpen, setSpellingOpen] = useState(false);


    useEffect(() => {
        const savedChildren = JSON.parse(
            localStorage.getItem("shadowGroveChildren") || "[]"
        );


        const savedChild = savedChildren.find((c) => c.child_id === childId);


        const nextChild = {
            ...savedChild,
            child_id: savedChild?.child_id || childId,
            name: savedChild?.name || "New Familiar",
            points: savedChild?.points ?? 0,
            coins: savedChild?.coins ?? 0,
            gems: savedChild?.gems ?? 0,
            arcade_coins: savedChild?.arcade_coins ?? 0,
        };


        setChild(nextChild);


        localStorage.setItem(
            "shadowGroveArcadeCoins",
            String(nextChild.arcade_coins)
        );
    }, [childId]);


    const updateChildArcadeCoins = (newAmount) => {
        const safeAmount = Math.max(0, newAmount);


        const updatedChild = {
            ...child,
            arcade_coins: safeAmount,
        };


        setChild(updatedChild);


        const savedChildren = JSON.parse(
            localStorage.getItem("shadowGroveChildren") || "[]"
        );


        const updatedChildren = savedChildren.map((kid) =>
            kid.child_id === childId ? updatedChild : kid
        );


        localStorage.setItem(
            "shadowGroveChildren",
            JSON.stringify(updatedChildren)
        );


        localStorage.setItem("shadowGroveArcadeCoins", String(safeAmount));
    };


    const totalSeconds = selectedMinutes * 60;
    const progress =
        totalSeconds > 0 ? Math.max(0, (timeLeft / totalSeconds) * 100) : 0;


    useEffect(() => {
        if (!approved || paused || timeLeft <= 0) return;


        const timer = setInterval(() => {
            setTimeLeft((t) => {
                if (t <= 1) {
                    clearInterval(timer);
                    setApproved(false);
                    toast("The Arcade gates have closed ✨");
                    return 0;
                }


                return t - 1;
            });
        }, 1000);


        return () => clearInterval(timer);
    }, [approved, paused, timeLeft]);


    useEffect(() => {
        if (paused) {
            localStorage.setItem(
                `arcadeTimer_${childId}`,
                JSON.stringify({
                    timeLeft,
                    approved,
                    paused,
                })
            );
        }
    }, [paused, timeLeft, approved, childId]);


    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem(`arcadeTimer_${childId}`));


        if (saved?.paused) {
            setTimeLeft(saved.timeLeft);
            setApproved(saved.approved);
            setPaused(true);
        }
    }, [childId]);


    const startArcade = () => {
        setTimeLeft(selectedMinutes * 60);
        setApproved(true);
        toast.success(`Arcade opened for ${selectedMinutes} minutes ✨`);
    };


    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s.toString().padStart(2, "0")}`;
    };


    return (
        <div className="min-h-screen bb-night-bg bb-stars">
            <header className="relative z-10 border-b border-[var(--bb-border)]">
                <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
                    <button
                        onClick={() => navigate(`/child/home/${childId}`)}
                        className="bb-btn-ghost flex items-center gap-2"
                    >
                        <ArrowLeft size={16} /> Back to working desk
                    </button>


                    <h1 className="font-display text-3xl text-[#ffd166]">
                        Liberi Arcade
                    </h1>


                    <span className="inline-flex items-center gap-1 rounded-full border border-[#ffd166]/35 bg-[#2b1548]/45 px-3 py-1 text-xs font-bold text-[#fff3c4] shadow-[0_0_16px_rgba(168,85,247,0.18)]">
                        <Gamepad2 size={12} />
                        {child?.arcade_coins ?? 0} Arcade Coins
                    </span>


                        <span className="hidden sm:block text-xs uppercase tracking-[0.2em] text-[#d8b4fe]">
                            Academy Leisure Hall
                        </span>
                    </div>
                
            </header>


            <main className="relative z-10 max-w-5xl mx-auto px-6 py-10 space-y-8">
                <section className="rounded-[32px] border border-[#ffd166]/35 bg-black/75 p-6 shadow-[0_0_30px_rgba(255,209,102,0.10)]">
                    <h2 className="font-display text-3xl text-[#ffd166] mb-2">
                        Parent Approval
                    </h2>


                    <p className="text-sm text-[#b0b8d6] mb-5">
                        Choose how long the arcade stays open. Games stay locked until approved.
                    </p>


                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
                        {[15, 30, 45, 60].map((m) => (
                            <button
                                key={m}
                                onClick={() => setSelectedMinutes(m)}
                                className={`rounded-2xl border p-4 text-center transition-all ${
                                    selectedMinutes === m
                                        ? "border-[#ffd166] bg-[#2b1548]/70 text-[#fff3c4] shadow-[0_0_20px_rgba(255,209,102,0.25)]"
                                        : "border-[#c084fc]/25 bg-[#160d26]/35 text-[#d8b4fe] hover:border-[#ffd166]/45 hover:text-[#fff3c4]"
                                }`}
                            >
                                <Clock size={18} className="mx-auto mb-2 text-[#ffd166]" />
                                {m} min
                            </button>
                        ))}
                    </div>


                    <button
                        onClick={startArcade}
                        className="inline-flex items-center gap-2 rounded-2xl border border-[#ffd166]/50 bg-[#2b1548]/75 px-5 py-3 font-semibold text-[#fff3c4] transition hover:border-[#ffd166] hover:text-[#ffd166]"
                    >
                        <ShieldCheck size={16} />
                        Parent Approve & Start Timer
                    </button>
                </section>


                <section className="rounded-[32px] border border-[#c084fc]/30 bg-[#0b0712]/80 p-6 shadow-[0_0_28px_rgba(168,85,247,0.12)]">
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="font-display text-2xl text-[#ffd166]">
                            Arcade Timer
                        </h2>


                        <span className="text-2xl font-bold text-[#ffd166]">
                            {approved ? formatTime(timeLeft) : "Locked"}
                        </span>
                    </div>


                    <div className="h-4 overflow-hidden rounded-full border border-[#ffd166]/20 bg-black/70">
                        <div
                            className="h-full bg-gradient-to-r from-[#7c3aed] via-[#c084fc] to-[#ffd166] transition-all duration-500"
                            style={{ width: `${progress}%` }}
                        />
                    </div>


                    <div className="mt-4 flex justify-center">
                        <button
                            onClick={() => {
                                setPaused((p) => {
                                    const next = !p;


                                    if (!next) {
                                        localStorage.removeItem(`arcadeTimer_${childId}`);
                                    }


                                    return next;
                                });
                            }}
                            className="rounded-2xl border border-[#ffd166]/45 bg-[#2b1548]/70 px-5 py-3 font-semibold text-[#fff3c4] transition hover:border-[#ffd166] hover:text-[#ffd166] disabled:cursor-not-allowed disabled:opacity-50"
                            disabled={!approved}
                        >
                            {paused ? "Resume Timer" : "Pause Timer"}
                        </button>
                    </div>
                </section>


                <section>
                    <h2 className="font-display text-2xl mb-3 text-[#ffd166]">
                        Learning Trials
                    </h2>


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        
                             <ArcadeCard
                             locked={!approved || paused}
                              icon={<BookOpen />}
                             title="Spelling Trials"
                             description="Practice spelling through guided trials or explore freely in the Rune Sandbox."
                              onClick={() => setSpellingOpen(true)}
/>


                        <ArcadeCard
                            locked={!approved || paused}
                            icon={<Sparkles />}
                            title="Vocabulary Maze"
                            description="Match words and definitions through magical paths."
                        />
                    </div>
                </section>


                <section>
                    <h2 className="font-display text-2xl mb-3 text-[#d8b4fe]">
                        Leisure Games
                    </h2>


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <ArcadeCard
                            locked={!approved || paused}
                            icon={<Star />}
                            title="Star Catcher"
                            description="Catch falling stars. Costs 5 Arcade Coins."
                            onClick={() => {
                                if ((child?.arcade_coins ?? 0) < 5) {
                                    toast.error("Not enough Arcade Coins ✨");
                                    return;
                                }


                                updateChildArcadeCoins((child?.arcade_coins ?? 0) - 5);
                                setGame("star");
                            }}
                        />


                        <ArcadeCard
                            locked={!approved || paused}
                            icon={<Sparkles />}
                            title="Memory"
                            description="Match cards. Costs 5 to 20 Arcade Coins by level."
                            onClick={() => {
                                localStorage.setItem(
                                    "shadowGroveArcadeCoins",
                                    String(child?.arcade_coins ?? 0)
                                );


                                setGame("memory");
                            }}
                        />


                        <ArcadeCard
                            locked={!approved || paused}
                            icon={<Gamepad2 />}
                            title="Star Mine"
                            description="Avoid cursed stars. Costs 5 to 20 Arcade Coins by level."
                            onClick={() => {
                                localStorage.setItem(
                                    "shadowGroveArcadeCoins",
                                    String(child?.arcade_coins ?? 0)
                                );


                                setGame("mine");
                            }}
                        />
                    </div>
                </section>
            </main>


            {game === "star" && (
                <StarCatchingGame
                    childId={childId}
                    onClose={() => setGame(null)}
                />
            )}


            {game === "memory" && (
                <MemoryGame
                    childId={childId}
                    onClose={() => setGame(null)}
                    onCoinsSpent={(amount) => {
                        updateChildArcadeCoins((child?.arcade_coins ?? 0) - amount);
                    }}
                />
            )}


            {game === "mine" && (
                <StarMineGame
                    childId={childId}
                    onClose={() => setGame(null)}
                    onCoinsSpent={(amount) => {
                        updateChildArcadeCoins((child?.arcade_coins ?? 0) - amount);
                    }}
                />
            )}


            
            {spellingOpen && (
    <SpellingSpells
        childId={childId}
        onClose={() => setSpellingOpen(false)}
        onCoinsEarned={(coinsEarned) => {
            updateChildArcadeCoins((child?.arcade_coins ?? 0) + coinsEarned);
        }}
    />
)}

        </div>
    );
};


const ArcadeCard = ({
    locked,
    icon,
    title,
    description,
    onClick,
}) => (
    <button
        type="button"
        onClick={
            !locked && onClick
                ? onClick
                : undefined
        }
        disabled={locked || !onClick}
        className={`
            w-full
            rounded-[28px]
            border
            p-5
            text-left
            transition-all
            duration-200
            ${
                locked
                    ? "cursor-not-allowed border-[#6b4d7d]/20 bg-black/45 opacity-50"
                    : onClick
                    ? "cursor-pointer border-[#c084fc]/30 bg-[#160d26]/50 shadow-[0_0_20px_rgba(124,58,237,0.10)] hover:border-[#ffd166]/65 hover:bg-[#2b1548]/55 hover:shadow-[0_0_26px_rgba(255,209,102,0.14)]"
                    : "cursor-default border-[#c084fc]/20 bg-[#0b0712]/55 opacity-70"
            }
        `}
    >
        <div className="flex items-start gap-4">
            <div
                className="
                    flex
                    h-11
                    w-11
                    shrink-0
                    items-center
                    justify-center
                    rounded-2xl
                    border
                    border-[#ffd166]/30
                    bg-[#2b1548]/65
                    text-[#ffd166]
                    shadow-[0_0_14px_rgba(168,85,247,0.16)]
                "
            >
                {locked ? (
                    <Lock size={18} />
                ) : (
                    icon
                )}
            </div>

            <div className="min-w-0 flex-1">
                <h3 className="font-display text-xl text-[#ffd166]">
                    {title}
                </h3>

                <p className="mt-1 text-sm leading-relaxed text-[#b0b8d6]">
                    {description}
                </p>

                <div className="mt-4">
                    <span
                        className={`
                            inline-flex
                            rounded-full
                            border
                            px-2.5
                            py-1
                            text-[10px]
                            font-semibold
                            uppercase
                            tracking-[0.16em]
                            ${
                                locked
                                    ? "border-[#6b4d7d]/25 text-[#7f7188]"
                                    : onClick
                                    ? "border-[#ffd166]/30 bg-[#ffd166]/5 text-[#fff3c4]"
                                    : "border-[#c084fc]/20 text-[#9ca3b7]"
                            }
                        `}
                    >
                        {locked
                            ? "Awaiting Parent Approval"
                            : onClick
                            ? "Ready"
                            : "Coming Soon"}
                    </span>
                </div>
            </div>
        </div>
    </button>
);


export default Arcade;
